import { createUpdateMessage } from './update-message';
const updateError = createUpdateMessage('Error');
/**
 * Returns a function to add a global error message.
 *
 * Emits a native browser event, keeping this package free of any dependency on redux
 * or the rest of the Famly app.
 *
 * @returns a function to add error messages to the global status bar without any dependencies
 * to the rest of the Famly app
 */
export function useUpdateError() {
    return updateError;
}
